<template>

	<section>

		<div class="columns">

			<div class="column is-half-desktop">

				<b-field horizontal label="Status">

		            <b-select placeholder="Select a status" v-model="contract.status" expanded>

		                <option value="1">Active</option>

		                <option value="0">Inactive</option>

		            </b-select>

		        </b-field>

				<b-field horizontal label="Contractor">

		            <b-select placeholder="Select" v-model="contract.contractor_firm_id" expanded>

						<option :value="firm.id" v-for="(firm, key) in contractors">{{ firm.name }}</option>

		            </b-select>

		        </b-field>

		        <b-field horizontal label="Name"> <b-input v-model="contract.name"></b-input> </b-field>

		        <b-field horizontal label="Code"> <b-input v-model="contract.code"></b-input> </b-field>



				<!-- <base-select
					:service="$options.contractService"
					fetch-func="listTypes"
					:value.sync="contract.type_tag_id"
					label="Contract Type"
					horizontal
				/> -->

				<base-combobox
					:value="editdata.typeTag ? editdata.typeTag.name : ''"
					:service="$options.contractService"
					fetch-func="listTypes"
					:fetch-params="{
						created_by_firm_id: organization ? organization.id : undefined
					}"
					fetch-on-init
					:create-service="$options.tagService"
					create-func="store"
					:create-params="{ type: '[CONTRACT][TYPE]' }"
					label="Contract Type"
					allow-new
					horizontal
					@select="option => contract.type_tag_id = option.id"
					@add-new="option => contract.type_tag_id = option.id"
					ref="typeTagCombobox"
				/>

				<b-field label="Start Date" horizontal>
					<b-datepicker
						v-model="start_date"
						icon="calendar"
						:date-formatter="dateFormatter"
					/>
				</b-field>

				<b-field label="End Date" horizontal>
					<b-datepicker
						v-model="end_date"
						icon="calendar"
						:date-formatter="dateFormatter"
					/>
				</b-field>

				<b-field horizontal label="Financial Month Start Day">
					<b-input
						v-model="contract.financial_month"
						type="number"
						min="1"
						max="28"
					/>
				</b-field>

				<b-field label="Next Scheduled Maintenance Generation Date" horizontal>
					<b-datetimepicker
						v-model="generate_schedule"
						icon="calendar"
						:datetime-formatter="datetimeFormatter"
						horizontal-time-picker
					/>
				</b-field>

	            <!-- <tags-input label="Tags" allow-new :values.sync="contract.selectedtags" only-type="[SYSTEM][CONTRACT][TYPE]" /> -->
				<base-tag-input
					horizontal
					:fetch-params="{ onlyType: '[SYSTEM][CONTRACT][TYPE]' }"
					attach-mode
					:value.sync="contract.selectedtags"
					model-type="contract"
					:model-id="editdata.id"
				/>

				<b-field horizontal>
					<section>
						<b-field
							v-for="permission in permissions"
							:key="`permission_${permission.id}`"
						>
							<b-checkbox
								v-model="contract.permission_ids"
								:native-value="permission.id"
							>
								{{ permission.name }}
							</b-checkbox>
						</b-field>
					</section>
				</b-field>

		        <div class="columns">

					<div class="column">
						<b-button type="is-default" expanded @click="$emit('update:edit', false)">Back</b-button>
					</div>

					<div v-if="canManageContract" class="column">
						<b-button type="is-info" expanded @click="save">Update</b-button>
					</div>

				</div>

			</div>

			<div class="column is-half-desktop">
				<tabs :firm="organization" :contract="editdata" />
			</div>

	    </div>

	</section>

</template>

<script>

import moment from "moment";

import { ContractService } from "@/services/contract.service";
import { PermissionService } from "@/services/permission.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import BaseTagInput from "@/components/partials/BaseTagInput";
import TagsInput from "@/components/partials/TagsInput";
import BaseSelect from "@/components/partials/BaseSelect";
import BaseCombobox from "@/components/partials/BaseCombobox";

import Tabs from "./partials/tabs";

const getStartCodeTypeValue = attributes => {
	let value;
	let attribute = attributes.find(attr => {
		return attr.code == '[SYSTEM][ORDER][CODE_CHAIN][START]';
	});
	if (attribute) {
		value = attribute.pivot ? attribute.pivot.value : attribute.value;
	}
	return value;
};

export default {

	contractService: ContractService,
	tagService: TagService,

	components:{
		Tabs,
		TagsInput,
		BaseTagInput,
		BaseSelect,
		BaseCombobox,
	},

	props: ['edit', 'organization', 'firm', 'contractors', 'editdata', 'canManageContract'],

    data() {

        return {

        	code_sets: [],

			permissions: [],

        	contract: {

	        	name: this.editdata.name,

	        	code: this.editdata.code,

	        	type: this.editdata.type,

	        	status: this.editdata.status,

	        	contractee_firm_id: this.organization.id,

	        	contractor_firm_id: this.editdata.contractor_firm_id,

	        	// start_code_type: getStartCodeTypeValue(this.editdata.attributes),

				permission_ids: (this.editdata.permissions || []).map(e => e.id),

	        	selectedtags: this.editdata.tags.map(element => element.name),

				type_tag_id: this.editdata.type_tag_id,

				financial_month: this.editdata.financial_month ? moment(this.editdata.financial_month).format("DD") : "",

        	},

			start_date: this.editdata.start_date ? new Date(this.editdata.start_date) : null,

			end_date: this.editdata.end_date ? new Date(this.editdata.end_date) : null,

			generate_schedule: this.editdata.generate_schedule ? new Date(this.editdata.generate_schedule) : null,

        }

    },

    mounted() {

    	this.$store.dispatch('routeLoading');
    	this.getRouteData().then(data => {
    		this.code_sets = data.code_sets || [];
    		this.permissions = data.permissions || [];
    	})
    	.finally(err => {
    		this.$store.dispatch('routeLoading', false);
    	});
    },

    methods: {

		dateFormatter(date) {
			return moment(date).format("DD/MM/YYYY");
		},

		datetimeFormatter(datetime) {
			return moment(datetime).format("DD/MM/YYYY HH:mm");
		},

		dateParser(date) {
			return moment(date)
				.tz(moment.tz.guess())
				.format();
		},

    	getRouteData() {
    		return new Promise((resolve, reject) => {
    			let data = {
					code_sets: [],
					permissions: [],
				};
    			Promise.all([
    				// this.getCodeSets(),
					this.getPermissions(),
    			])
    			.then(all => {
    				// data.code_sets = all[0];
					data.permissions = all[0];
    				resolve(data);
    			}).catch(err => {
    				reject(err);
    			});
    		});
    	},

    	getCodeSets() {
    		return ContractService.getCodeSets();
    	},

		getPermissions() {
			return PermissionService.all({ type: "contract" })
				.then(response => JsonDenormalizer.denormalize(response));
		},

    	save() {

    		if ( ! this.canManageContract) return;

			let financial_month = null;
			if (this.contract.financial_month) {
				financial_month = moment();
				financial_month.date(this.contract.financial_month);
				financial_month.startOf("day");
				financial_month = this.dateParser(financial_month);
			}

    		ContractService.update(this.editdata.id, {
				...this.contract,
				start_date: this.start_date ? this.dateParser(this.start_date) : undefined,
				end_date: this.end_date ? this.dateParser(this.end_date) : undefined,
				generate_schedule: this.generate_schedule ? this.dateParser(this.generate_schedule) : undefined,
				financial_month: financial_month || undefined,
			}).then(response => {

    			this.$emit('update:edit', false)

			});

    	},

    },

}

</script>



// WEBPACK FOOTER //
// src/components/pages/Contracts/edit.vue